import { createApp } from "vue";
import { createPinia } from "pinia";
import { useConfigStore } from "./stores/configStore";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";

const config = JSON.parse(document.getElementById("config").innerHTML);

Bugsnag.start({
  apiKey: "01c6f0819ebe7e1d502d5e38ee0b336d",
  appVersion: config.bugsnag.appVersion,
  releaseStage: config.bugsnag.releaseStage,
  enabledReleaseStages: config.bugsnag.enabledReleaseStages,
  plugins: [new BugsnagPluginVue()],
});

const app = createApp(App).use(createPinia());

app.use(VueGtag, {
  config: { id: config.google.analytics.trackingId },
});

app.use(Bugsnag.getPlugin("vue"));

const configStore = useConfigStore();

configStore.config = config;

app.mount("#app");
